module.exports = {
  CORPORATE: 'corporate',
  PERSONAL: 'personal',
};
